module.exports = __webpack_public_path__ + "static/media/snow.b81ad62e.gif";